export const DATA_4 = {
    name: '香港學生運動',
    tabs: [
        {
            name: '報章評論',
            url: 'http://news.example.com/hk-student-exercise-health',
            contents: [
                {
                    type: 'image',
                    src: '/secondary/tasks/B2-P1-banner.png',
                },
                {
                    type: 'html',
                    html: `<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港學生缺乏定期運動的問題愈來愈值得關注。過去的兒童可能有較多機會參與戶外活動；然而，在智能手機和數碼科技普及的今天，要完全回到從前的生活方式並不現實。運動不足可能增加健康風險，甚至使部分疾病提早出現。因此，家庭和學校更需要採取行動，幫助學生保持足夠的運動量，建立較健康和有規律的生活習慣。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;衞生署一份涵蓋約42.8萬名中小學生的報告顯示，93.6%的學生沒有每天進行足夠的中等至劇烈強度體能活動。報告亦指出，學生普遍面對娛樂性螢幕時間過長等問題。不少學生在完成學習需要以外，仍會長時間使用手機觀看短片、玩遊戲或瀏覽社交媒體。這些情況可能與生活方式改變有關。不少家長的童年在智能手機尚未普及的年代度過，當時可能有較多戶外活動。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;相比之下，現今智能手機和數碼科技普及，學生花在電子產品上的時間增加，參與體能活動的機會可能相對減少。衞生署社會醫學顧問張竹君醫生指出，兒童及青少年時期超重會對健康造成不良影響，並與多種疾病有關，包括二型糖尿病、心血管疾病和部分癌症。醫學雖然能治療疾病，但及早預防始終更為重要。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;政府呼籲家長和學校共同應對學生體能活動不足的問題。家長重視子女的學業成績固然可以理解，但學習與運動並非互相排斥。增加運動也不一定意味着要大幅減少溫習時間，關鍵是能否在日常作息中作出較合理的安排，避免長時間保持靜態活動，並為體能活動預留適當時間。學校亦可在課堂、課外活動和健康教育中幫助學生建立相關意識。適量的運動和健康的生活方式同樣有助學生保持良好狀態，並適應快速轉變的社會。
                    <br/><br/>
                    <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自《南華早報》
                    </div><br/><br/>`,
                }
            ]
        },
        {
            name: '衞生署資訊',
            url: 'http://health.example.com/student-physical-activity',
            contents: [
                {
                    type: 'html',
                    html: `<div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%;'>
                        <div class='w-full font-bold text-white flex flex-row items-center' style='background-color: #3F96FD; padding: 16px; gap:16px;'>
                            <div style='width:12px; height:39px; background-color: #FF7961;'></div>
                            衞生署資訊 | 學生的運動量足夠嗎？
                        </div>

                            <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;衞生署每年為全港中、小學生提供周年健康檢查服務及健康評估問卷，並整理相關結果，發表《學生健康服務周年健康報告》。衞生署指出，評估體能活動時，需要同時考慮活動時間和活動強度。
                            <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;體能活動並不只限於穿上運動服跑步、打籃球等正式運動。日常生活中，只要身體活動增加並消耗能量，都可以屬於體能活動。因此，學生可以把活動融入日常生活，逐步建立恆常運動的習慣。不過，不同活動對身體造成的負荷並不相同，單看活動名稱未必能準確判斷強度。較簡單的方法，是觀察活動時的心率、呼吸和說話情況。例如，有些活動只會令心率和呼吸稍微增加，有些活動則會令人明顯氣喘，交談亦變得困難。
                            <br/><br/><br/>
                            <table class='w-full' style='border: 1px solid #9CB8D3;'>
                                <tr>
                                    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>運動強度</th>
                                    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>身體反應</th>
                                    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>活動例子</th>
                                </tr>
                                <tr>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>低強度</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>心率與呼吸無影響，活動時能自在唱歌</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>逛商場</td>
                                </tr>
                                <tr>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>中等強度</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>心率與呼吸微增，活動時能說話但不能唱歌</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>游泳</td>
                                </tr>
                                <tr>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>高／劇烈強度</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>心跳與呼吸加快，活動時難以交談</td>
                                    <td class='text-center' style='border: 1px solid #9CB8D3;'>打籃球</td>
                                </tr>
                                </table>
                                <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                        資料來源：衞生署衞生防護中心《非傳染病直擊》，2026年
                            </div>

                           
                             <br/>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024/25學年的資料顯示，學生體能活動不足仍是值得關注的問題。以下圖表顯示近年中、小學生在過去七天沒有每天進行至少60分鐘中等至劇烈強度體能活動的比例。</p>
                            <br/>
                             <b>圖1：2018/19至2024/25學年學生在過去七天沒有每天進行至少60分鐘中等至劇烈強度體能活動的比例</b>
                             <br/>
                    </div>`
                },
                {
                    type: 'image',
                    src:'/secondary/tasks/B2-P2-image.png',
                    alt: '圖1：2018/19至2024/25學年學生在過去七天沒有每天進行至少60分鐘中等至劇烈強度體能活動的比例',
                    enableEnlargeAndRecordTimeSpent: true,
                    backgroundColor: 'white'
                },
                {
                    type: 'html',
                    html: `<div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%;'>
                            <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                註：^ 因受到新冠疫情影響，2019/20、2020/21和2021/22學年的數字不能直接與其他學年的數據進行比較。基於精確度的考慮，2020/21學年數字不予公佈。
                    </div><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了活動時間和強度，進行運動時亦要留意方法和安全。衞生署建議兒童及青少年按照自己的興趣和能力選擇合適的活動，並循序漸進地增加運動量，避免一開始便勉強自己進行過量或過於劇烈的運動。運動前應先做好熱身，讓身體逐步進入活動狀態；完成主要活動後，也應進行適當的緩和和伸展。若運動期間出現明顯不適，則應停止活動和休息。與家人或朋友一同參與，也有助把運動逐步融入日常生活。</p>
                            
                            <br/>
                            <br/>
                    </div>`,
                },

            ]
        }
    ],
    questions: [
        {
            type: "display-text",
            html: '學校正籌備「健康生活週」，你和子晴、嘉朗負責製作一塊關於學生健康的專題展板。搜集資料時，你們先讀到下列一篇討論香港學生運動與健康問題的報章評論。<br/><br/>點擊「下一頁」來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 報章評論中提到「學生普遍面對娛樂性螢幕時間過長等問題」，這裏所說的「娛樂性螢幕時間」主要是指甚麼？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 用手機學習以及觀看短片' },
                { text: 'B. 用手機看短片以及玩遊戲', correct: true },
                { text: 'C. 用手機與同學討論課業內容' },
                { text: 'D. 用手機搜尋和查閱學習資料' },
            ],
            tab: 0,
        },
        {
            id: '2',
            type: '選擇題',
            question: '2. 以下哪項判斷最能概括報章評論的整體觀點？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 家校應正視健康，兼顧學習、運動和作息', correct: true },
                { text: 'B. 數碼科技影響健康，重點應管理螢幕時間' },
                { text: 'C. 學生超重值得關注，學校應以量體重為主' },
                { text: 'D. 過往戶外活動較多，學生應恢復昔日生活' },
            ],
            tab: 0,
        },
        {
            id: '3',
            type: '選擇題',
            question: '3.	報章評論第三段指出：「醫學雖然能治療疾病，但及早預防始終更為重要。」這種表達主要有甚麼作用？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 透過舉例說明，突出疾病治療的效果' },
                { text: 'B. 透過因果說明，解釋運動不足的後果' },
                { text: 'C. 透過列舉比較，說明不同疾病的影響' },
                { text: 'D. 透過轉折對比，突出及早預防的重要', correct: true },
            ],
            tab: 0,
        },
        {
            type: "display-text",
            html: '讀完評論後，嘉朗提議展板的內容要更具體：除了列出數字，也要讓同學明白甚麼程度的運動才算足夠。於是，你們到衞生署網站搜集資料，找到以下資料。<br/><br/>點擊「下一頁」來閱讀第二個來源。'
        },
        {
            id: '4',
            type: '填寫問題',
            subtitle: '參考右側「衞生署資訊」，作答本題。',
            question_prefix: '4.	根據圖1，在已有公佈數據的學年中，哪一學年的中學生運動不足比例最低？\n',
            question_prefix_: '答案： 20',
            question_postfix_: '/',
            question_postfix: ' 學年',
            isMultipleAnswer: true,
            correct: '22',
            correct2: '23'

        },
        {
            id: '5',
            type: '拖放式問題',
            question: '5. 根據衞生署資訊、運動強度表及圖1，把下列選項拖放到①至③。',
            subtitle: '參考右側「衞生署資訊」，作答本題。',
            dragAndDrop: [
                {
                    title: '現象',
                    rows: [
                        { type: "拖放格", correct: 'A. 已公佈數據中，超九成中學生運動量少於建議運動量。' },
                        { type: "文字", text: '樂怡平日很少運動，第一次打網球時，心跳和呼吸加快，而且難以交談。' },
                        { type: "拖放格", correct: 'E. 兩人都在打網球，但一人還能唱歌，另一人卻難以交談。' },
                    ]
                },
                {
                    title: '可作出的推斷',
                    rows: [
                        { type: "文字", text: '近年香港中學生體能活動不足的情況仍然普遍' },
                        { type: "拖放格", correct: 'B. 她不宜一開始便進行這種強度的運動，應逐步增加運動量。' },
                        { type: "文字", text: '兩人的活動名稱相同，實際運動強度仍可能不同。' },
                    ]
                },
                {
                    title: '來源',
                    rows: [
                        { type: "文字", text: '衞生署圖1' },
                        { type: "文字", text: '衞生署資料及運動強度表' },
                        { type: "文字", text: '衞生署資料及運動強度表' },
                    ]
                },
            ],
            dragAndDropOptions: [
                { text: 'A. 已公佈數據中，超九成中學生運動量少於建議運動量。' },
                { text: 'B. 她不宜一開始便進行這種強度的運動，應逐步增加運動量。' },
                { text: 'C. 兩人分別進行跑步和游泳，運動時都呼吸急促、難以交談。' },
                { text: 'D. 進行這項運動時能正常說話，這項活動便屬於低強度活動。' },
                { text: 'E. 兩人都在打網球，但一人還能唱歌，另一人卻難以交談。' },
                { text: 'F. 活動名稱相同，進行的運動強度也可以視為接近。' },
            ],
        },
        {
            id: '6',
            type: '選擇題',
            question: '6. 圖表沒有公佈2020/21學年的數字。以下哪項判斷最恰當？',
            subtitle: '參考右側「衞生署資訊」，作答本題。',
            options: [
                { text: 'A. 該年沒有學生運動不足，所以沒有公佈數字' },
                { text: 'B. 該年受疫情影響，因此可沿用前一學年的比例' },
                { text: 'C. 該年數字未公佈，不能據此判斷運動不足比例', correct: true },
                { text: 'D. 該年改用不同的運動標準，所以沒有公佈數字' },
            ],
            tab: 1,
        },
        {
            id: '7',
            type: '表格問題',
            question: '7. 根據衞生署資料、運動強度表及圖1，判斷以下說法是否正確。',
            subtitle: '參考右側「衞生署資訊」，作答本題。',
            header: ["陳述", "正確", "錯誤"],
            table: [
                { text: '（1）在已有公佈數據的學年中，中學生運動不足的比例一直高於小學生。', correct: 1 },
                { text: '（2）2022/23至2024/25學年間小學生運動不足的比例逐年下降，因此小學生運動不足的人數逐年減少。', correct: 2 },
                { text: '（3）中學生運動不足比例最高的學年是2021/22學年，其數據可與最新學年直接比較。', correct: 2 },
                { text: '（4）只記錄學生每天的運動時間，便能判斷其體能活動是否足夠。', correct: 2 },
            ],
        },
        {
            id: '8',
            type: '表格問題2',
            question: '8. 某社區中心準備試辦課後運動班，由於名額有限，希望優先服務圖1最新學年中運動不足比例較高的一組學生。綜合兩個來源及圖1，以下哪個方案最合適？',
            subtitle: '結合兩個來源，作答本題。',
            table: [
                {
                    title: ' ',
                    rows: [
                        'A',
                        'B',
                        'C',
                        'D'
                    ]
                },
                {
                    title: '優先對象',
                    rows: [
                        "中學生",
                        "中學生",
                        "小學生",
                        "小學生"
                    ]
                },
                {
                    title: '時間安排',
                    rows: [
                        '減少部分電子娛樂時間',
                        '主要減少溫習時間',
                        '減少部分電子娛樂時間',
                        '主要減少溫習時間',
                    ]
                },
                {
                    title: '運動安排',
                    rows: [
                        '按能力逐步增加',
                        '按同一標準增加',
                        '按同一標準增加',
                        '按能力逐步增加'
                    ]
                }
            ],
            tab: 1,
            correct: 'A'
        },
        {
            id: '9',
            type: '選擇題',
            question: '9. 子晴在製作展板時，想要挑選出兩個來源都有直接依據的內容。以下哪項符合條件？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 電子產品使用增加，導致減少運動機會。' },
                { text: 'B. 學生運動不足情況普遍，健康問題仍要關注。', correct: true },
                { text: 'C. 運動前需要做好熱身，運動後需要足夠伸展。' },
                { text: 'D. 高強度運動效果更好，學生應優先選擇。' },
            ],
            tab: 1,
        },
        {
            id: '10',
            type: '短句作答題',
            question: '10.	評論一方面指出運動需要預留時間，另一方面又說增加運動不一定要大幅減少溫習時間。這兩項說法是否矛盾？請根據評論內容進行解釋。',
            subtitle: '參考右側的「報章評論」，作答本題。',
            score: 4
        }
    ]
}
